import { noop } from 'tg-commons'
import { defineComponent, type App } from 'vue'
import { useComponentName } from './hooks'
import type { VueHookName } from './vue-utils'

const DEFAULT_EXCLUDE_HOOK_NAMES: VueHookName[] = ['beforeUpdate', 'updated']

export interface LifecycleLogOptions {
  /** @default /^[A-Z]/ 匹配大写字母开头的组件名 */
  nameRegex?: RegExp
  /** @default true 开启log */
  enable?: boolean,
  /** @default 除 updated, beforeUpdate 外的所有hook */
  hookNames?: VueHookName[]
}

const LifecycleLogPlugin = {
  install(app: App, options: LifecycleLogOptions = {}) {
    if (options.enable !== false) {
      const lifecycleLogMixin = defineComponent({
        beforeCreate() {
          const componentName = useComponentName() ?? ''
          const matched = (options.nameRegex || /^[A-Z]/).test(componentName)
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const __life = matched
            ? (hookName: VueHookName) => {
                if (options.hookNames) {
                  if (options.hookNames.includes(hookName)) {
                    console.debug('[lifecycle]', componentName, hookName)
                  }
                } else if (!DEFAULT_EXCLUDE_HOOK_NAMES.includes(hookName)) {
                  console.debug('[lifecycle]', componentName, hookName)
                }
              }
            : noop
          // `beforeCreate`触发在data/props/methods等组件状态初始化之前, 所以若`__life`方法直接在methods中实现, 在这里是调用不到的(
          __life('beforeCreate')
          ; (this as any).__life_impl = __life
        },
        created() {
          this.__life('created')
        },
        beforeMount() {
          this.__life('beforeMount')
        },
        mounted() {
          this.__life('mounted')
        },
        beforeUpdate() {
          this.__life('beforeUpdate')
        },
        updated() {
          this.__life('updated')
        },
        beforeUnmount() {
          this.__life('beforeUnmount')
        },
        unmounted() {
          this.__life('unmounted')
        },
        methods: {
          __life(hookName: VueHookName) {
            (this as any).__life_impl(hookName)
          },
        },
        onCreate() {
          this.__life('onCreate')
        },
        onDestroy() {
          this.__life('onDestroy')
        },
      })
      app.mixin(lifecycleLogMixin as any)
    }
  },
}
export default LifecycleLogPlugin
